export default (size) => {
  return size.key === 'empty' ? '' : size.label;
};
